import { render, staticRenderFns } from "./NumeroSiniestroConSvg.vue?vue&type=template&id=ae943494&"
import script from "./NumeroSiniestroConSvg.vue?vue&type=script&lang=js&"
export * from "./NumeroSiniestroConSvg.vue?vue&type=script&lang=js&"
import style0 from "./NumeroSiniestroConSvg.vue?vue&type=style&index=0&id=ae943494&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports